import { render } from "./SurveyItem.vue?vue&type=template&id=5de3b875"
import script from "./SurveyItem.vue?vue&type=script&lang=js"
export * from "./SurveyItem.vue?vue&type=script&lang=js"

import "./SurveyItem.vue?vue&type=style&index=0&id=5de3b875&lang=scss"

import exportComponent from "/home/jeim2750/develop.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__